export interface Movie {
  id: number;
  title: string;
  englishTitle: string;
  poster: string;
  year: number;
  category: string;
  subcategory: string;
  rating: number;
  duration: string;
  region: string;
  director: string;
  actors: string[];
  description: string;
  tags: string[];
  isHot: boolean;
  isNew: boolean;
  isVip: boolean;
  updateDate: string;
  episodeInfo: string;
  stills: string[];
}

export const categories = [
  { slug: 'dianying', name: '电影', icon: 'ri-film-line' },
  { slug: 'dianshiju', name: '电视剧', icon: 'ri-tv-line' },
  { slug: 'zongyi', name: '综艺', icon: 'ri-live-line' },
  { slug: 'dongman', name: '动漫', icon: 'ri-emotion-line' },
];

export const subcategories: Record<string, { slug: string; name: string }[]> = {
  dianying: [
    { slug: 'all', name: '全部' },
    { slug: 'dongzuo', name: '动作片' },
    { slug: 'xiju', name: '喜剧片' },
    { slug: 'aiqing', name: '爱情片' },
    { slug: 'kehuan', name: '科幻片' },
    { slug: 'kongbu', name: '恐怖片' },
    { slug: 'juzhi', name: '剧情片' },
    { slug: 'zhanzheng', name: '战争片' },
    { slug: 'jilupian', name: '纪录片' },
  ],
  dianshiju: [
    { slug: 'all', name: '全部' },
    { slug: 'guochan', name: '国产剧' },
    { slug: 'gangtai', name: '港台剧' },
    { slug: 'rihan', name: '日韩剧' },
    { slug: 'oumei', name: '欧美剧' },
    { slug: 'haiwai', name: '海外剧' },
  ],
  zongyi: [
    { slug: 'all', name: '全部' },
    { slug: 'dalu', name: '大陆综艺' },
    { slug: 'gangtai', name: '港台综艺' },
    { slug: 'rihan', name: '日韩综艺' },
    { slug: 'oumei', name: '欧美综艺' },
  ],
  dongman: [
    { slug: 'all', name: '全部' },
    { slug: 'guoman', name: '国漫' },
    { slug: 'riman', name: '日漫' },
    { slug: 'oumeiman', name: '欧美动漫' },
    { slug: 'dianyingdongman', name: '动画电影' },
  ],
};

export const movies: Movie[] = [
  {
    id: 1,
    title: '龙渊之战',
    englishTitle: 'Battle of Dragon Abyss',
    poster: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20fantasy%20film%20poster%20with%20ancient%20dragon%20and%20warrior%2C%20dark%20dramatic%20lighting%2C%20cinematic%20movie%20poster%20style%2C%20golden%20and%20crimson%20accents%2C%20clean%20dark%20background%2C%20professional%20film%20poster%20design&width=600&height=840&seq=movie-poster-01&orientation=portrait',
    year: 2026,
    category: 'dianying',
    subcategory: 'dongzuo',
    rating: 8.5,
    duration: '128分钟',
    region: '中国大陆',
    director: '陈凯歌',
    actors: ['张译', '吴京', '章子怡', '易烊千玺'],
    description: '上古时期，龙渊大陆陷入战乱。一位被命运选中的少年，在神秘老者的指引下，踏上了寻找传说中龙渊之力的征程。一路上，他结识了志同道合的伙伴，共同对抗黑暗势力，最终揭开了龙渊大陆尘封千年的秘密。',
    tags: ['奇幻', '动作', '冒险', '史诗'],
    isHot: true,
    isNew: true,
    isVip: false,
    updateDate: '2026-08-10',
    episodeInfo: 'HD1080P',
    stills: [
      'https://readdy.ai/api/search-image?query=Epic%20fantasy%20battle%20scene%20with%20Chinese%20warriors%20and%20dragons%2C%20dramatic%20cinematic%20lighting%2C%20dark%20atmospheric%20mood%2C%20professional%20film%20cinematography&width=800&height=450&seq=still-01-1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20temple%20in%20misty%20mountains%2C%20cinematic%20wide%20shot%2C%20mysterious%20atmosphere%2C%20film%20scene%20with%20dramatic%20lighting&width=800&height=450&seq=still-01-2&orientation=landscape',
    ],
  },
  {
    id: 2,
    title: '都市夜话',
    englishTitle: 'City Night Tales',
    poster: 'https://readdy.ai/api/search-image?query=Modern%20Chinese%20romance%20drama%20film%20poster%2C%20couple%20in%20city%20night%20with%20neon%20lights%2C%20cinematic%20aesthetic%2C%20warm%20tone%20accents%2C%20clean%20composition%2C%20professional%20movie%20poster&width=600&height=840&seq=movie-poster-02&orientation=portrait',
    year: 2026,
    category: 'dianying',
    subcategory: 'aiqing',
    rating: 7.9,
    duration: '112分钟',
    region: '中国大陆',
    director: '薛晓路',
    actors: ['刘亦菲', '彭于晏', '倪妮', '朱一龙'],
    description: '在北京繁华的都市夜色中，三个不同年龄段的男女面临着各自的情感抉择。年轻的创业者、中年的职场精英、退休的老教授，他们在都市丛林中寻找属于自己的幸福，也重新定义了爱情的模样。',
    tags: ['爱情', '都市', '剧情', '文艺'],
    isHot: true,
    isNew: false,
    isVip: true,
    updateDate: '2026-07-28',
    episodeInfo: 'HD1080P',
    stills: [
      'https://readdy.ai/api/search-image?query=Modern%20city%20night%20scene%20with%20neon%20lights%20reflecting%20on%20wet%20street%2C%20romantic%20cinematic%20shot%2C%20urban%20aesthetic&width=800&height=450&seq=still-02-1&orientation=landscape',
    ],
  },
  {
    id: 3,
    title: '星际迷航：新纪元',
    englishTitle: 'Star Trek: New Era',
    poster: 'https://readdy.ai/api/search-image?query=Sci-fi%20space%20film%20poster%20with%20futuristic%20spaceship%20and%20galaxy%20background%2C%20cinematic%20movie%20poster%20style%2C%20deep%20space%20colors%2C%20clean%20dark%20backdrop%2C%20professional%20design&width=600&height=840&seq=movie-poster-03&orientation=portrait',
    year: 2026,
    category: 'dianying',
    subcategory: 'kehuan',
    rating: 8.8,
    duration: '145分钟',
    region: '美国',
    director: '克里斯托弗·诺兰',
    actors: ['汤姆·克鲁斯', '安雅·泰勒-乔伊', '基里安·墨菲'],
    description: '在遥远的未来，人类已经掌握了星际旅行的技术。一支勇敢的探险队踏上了前往未知星系的征程，他们将在宇宙最深处发现一个足以改变人类命运的秘密。这不仅仅是一次太空探索，更是对人类文明本质的终极叩问。',
    tags: ['科幻', '冒险', '太空', '巨制'],
    isHot: true,
    isNew: true,
    isVip: true,
    updateDate: '2026-08-08',
    episodeInfo: '4K HDR',
    stills: [
      'https://readdy.ai/api/search-image?query=Futuristic%20spaceship%20approaching%20a%20mysterious%20planet%20in%20deep%20space%2C%20cinematic%20sci-fi%20scene%2C%20dramatic%20lighting&width=800&height=450&seq=still-03-1&orientation=landscape',
    ],
  },
  {
    id: 4,
    title: '笑傲江湖之东方不败',
    englishTitle: 'Swordsman: The Invincible East',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20film%20poster%20with%20warrior%20in%20red%20robes%20holding%20sword%2C%20ancient%20Chinese%20aesthetic%2C%20dramatic%20cinematic%20style%2C%20dark%20moody%20background&width=600&height=840&seq=movie-poster-04&orientation=portrait',
    year: 2025,
    category: 'dianying',
    subcategory: 'dongzuo',
    rating: 8.2,
    duration: '135分钟',
    region: '中国香港',
    director: '徐克',
    actors: ['甄子丹', '周迅', '陈坤', '张震'],
    description: '改编自金庸经典武侠小说。日月神教教主东方不败修炼葵花宝典后功力大增，却也因此性情大变。江湖各派联手围剿黑木崖，一场惊天动地的武林浩劫即将展开。刀光剑影间，谁才是真正的天下第一？',
    tags: ['武侠', '动作', '古装', '经典'],
    isHot: false,
    isNew: false,
    isVip: false,
    updateDate: '2025-12-15',
    episodeInfo: 'HD1080P',
    stills: [
      'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20martial%20arts%20battle%20on%20mountain%20peak%2C%20dramatic%20red%20fabric%20flowing%2C%20cinematic%20wide%20shot&width=800&height=450&seq=still-04-1&orientation=landscape',
    ],
  },
  {
    id: 5,
    title: '深夜食堂：彼岸花',
    englishTitle: 'Midnight Diner:彼岸花',
    poster: 'https://readdy.ai/api/search-image?query=Warm%20cozy%20Japanese%20style%20diner%20at%20night%20film%20poster%2C%20soft%20lighting%2C%20heartwarming%20drama%20aesthetic%2C%20clean%20composition%2C%20cinematic%20poster%20design&width=600&height=840&seq=movie-poster-05&orientation=portrait',
    year: 2026,
    category: 'dianying',
    subcategory: 'juzhi',
    rating: 8.0,
    duration: '108分钟',
    region: '日本',
    director: '是枝裕和',
    actors: ['小林薰', '绫濑遥', '佐藤健', '长泽雅美'],
    description: '深夜时分，城市角落里一家不起眼的小食堂依然亮着灯。老板用简单的食材，为每一位深夜到访的客人烹制专属的料理。每一道菜背后，都藏着一个温暖人心的故事。今晚，又会是谁推开这扇门？',
    tags: ['剧情', '美食', '温情', '治愈'],
    isHot: false,
    isNew: true,
    isVip: false,
    updateDate: '2026-08-05',
    episodeInfo: 'HD1080P',
    stills: [
      'https://readdy.ai/api/search-image?query=Cozy%20Japanese%20diner%20interior%20at%20night%20with%20warm%20lighting%2C%20steaming%20food%20on%20counter%2C%20cinematic%20shot&width=800&height=450&seq=still-05-1&orientation=landscape',
    ],
  },
  {
    id: 6,
    title: '暗夜追踪',
    englishTitle: 'Night Chase',
    poster: 'https://readdy.ai/api/search-image?query=Suspense%20thriller%20film%20poster%20with%20detective%20in%20rainy%20city%20at%20night%2C%20noir%20cinematic%20style%2C%20dark%20moody%20atmosphere%2C%20professional%20movie%20poster&width=600&height=840&seq=movie-poster-06&orientation=portrait',
    year: 2026,
    category: 'dianying',
    subcategory: 'kongbu',
    rating: 7.6,
    duration: '118分钟',
    region: '韩国',
    director: '奉俊昊',
    actors: ['宋康昊', '金惠秀', '李政宰', '全智贤'],
    description: '首尔连续发生多起离奇失踪案件，刑警朴振宇在调查过程中发现，所有线索都指向一个神秘的地下组织。随着调查深入，他发现自己已经深陷一个巨大的阴谋之中，而真相远比想象中更加可怕。',
    tags: ['悬疑', '惊悚', '犯罪', '推理'],
    isHot: false,
    isNew: false,
    isVip: true,
    updateDate: '2026-06-20',
    episodeInfo: 'HD1080P',
    stills: [
      'https://readdy.ai/api/search-image?query=Dark%20rainy%20alley%20in%20Seoul%20at%20night%2C%20detective%20silhouette%2C%20suspenseful%20cinematic%20scene%2C%20film%20noir%20aesthetic&width=800&height=450&seq=still-06-1&orientation=landscape',
    ],
  },
  {
    id: 7,
    title: '长安十二时辰',
    englishTitle: 'The Longest Day in Chang\'an',
    poster: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20Tang%20Dynasty%20city%20drama%20poster%2C%20grand%20palace%20and%20market%20scene%2C%20historical%20epic%20aesthetic%2C%20rich%20warm%20tones%2C%20cinematic%20TV%20series%20poster&width=600&height=840&seq=movie-poster-07&orientation=portrait',
    year: 2025,
    category: 'dianshiju',
    subcategory: 'guochan',
    rating: 9.1,
    duration: '48集',
    region: '中国大陆',
    director: '曹盾',
    actors: ['雷佳音', '易烊千玺', '周一围', '热依扎'],
    description: '唐朝天宝三载，上元节前夕，长安城陷入了一场空前的危机。死囚张小敬临危受命，要在十二个时辰内找出潜伏在长安城中的刺客，阻止一场足以毁灭整座城市的阴谋。时间紧迫，步步惊心。',
    tags: ['古装', '悬疑', '历史', '精品'],
    isHot: true,
    isNew: false,
    isVip: false,
    updateDate: '2025-08-01',
    episodeInfo: '更新至48集',
    stills: [
      'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20Tang%20Dynasty%20city%20street%20market%20scene%2C%20grand%20scale%20historical%20drama%2C%20cinematic%20lighting&width=800&height=450&seq=still-07-1&orientation=landscape',
    ],
  },
  {
    id: 8,
    title: '幸福到万家',
    englishTitle: 'Happiness to Thousands of Homes',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20rural%20family%20drama%20poster%2C%20warm%20village%20scene%20with%20smiling%20family%2C%20heartwarming%20TV%20series%20aesthetic%2C%20clean%20bright%20composition&width=600&height=840&seq=movie-poster-08&orientation=portrait',
    year: 2026,
    category: 'dianshiju',
    subcategory: 'guochan',
    rating: 8.3,
    duration: '40集',
    region: '中国大陆',
    director: '郑晓龙',
    actors: ['赵丽颖', '刘威', '唐曾', '罗晋'],
    description: '讲述了农村姑娘何幸福嫁到万家庄后，凭借自己的勤劳和智慧，带领全村人共同致富的故事。在面对传统观念与现代文明的碰撞中，何幸福始终保持着乐观向上的态度，最终收获了事业与爱情的双丰收。',
    tags: ['农村', '励志', '家庭', '温情'],
    isHot: false,
    isNew: true,
    isVip: false,
    updateDate: '2026-08-09',
    episodeInfo: '更新至32集',
    stills: [
      'https://readdy.ai/api/search-image?query=Beautiful%20Chinese%20rural%20village%20with%20golden%20fields%2C%20warm%20sunlight%2C%20heartwarming%20atmosphere&width=800&height=450&seq=still-08-1&orientation=landscape',
    ],
  },
  {
    id: 9,
    title: '逆流而上',
    englishTitle: 'Against the Current',
    poster: 'https://readdy.ai/api/search-image?query=Korean%20drama%20poster%20with%20businessman%20in%20modern%20office%2C%20corporate%20drama%20aesthetic%2C%20clean%20professional%20style%2C%20cinematic%20poster%20design&width=600&height=840&seq=movie-poster-09&orientation=portrait',
    year: 2026,
    category: 'dianshiju',
    subcategory: 'rihan',
    rating: 8.7,
    duration: '16集',
    region: '韩国',
    director: '金元锡',
    actors: ['宋仲基', '金智媛', '李星民', '金惠允'],
    description: '一位在大企业工作了十五年的中层管理者，在遭遇职场危机后选择创业。从零开始的创业之路充满艰辛，但他凭借着过人的毅力和商业嗅觉，一步步将小公司发展成行业新星。这是一个关于勇气、坚持和奋斗的故事。',
    tags: ['职场', '励志', '创业', '韩剧'],
    isHot: true,
    isNew: true,
    isVip: true,
    updateDate: '2026-08-11',
    episodeInfo: '更新至12集',
    stills: [
      'https://readdy.ai/api/search-image?query=Modern%20Korean%20office%20interior%20with%20city%20view%2C%20professional%20workplace%20drama%20scene%2C%20cinematic%20lighting&width=800&height=450&seq=still-09-1&orientation=landscape',
    ],
  },
  {
    id: 10,
    title: '脱口秀大会第六季',
    englishTitle: 'Roast! Season 6',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20talk%20show%20poster%20with%20colorful%20stage%20design%2C%20variety%20show%20aesthetic%2C%20bright%20energetic%20style%2C%20clean%20composition&width=600&height=840&seq=movie-poster-10&orientation=portrait',
    year: 2026,
    category: 'zongyi',
    subcategory: 'dalu',
    rating: 8.1,
    duration: '12期',
    region: '中国大陆',
    director: '',
    actors: ['李诞', '王建国', '庞博', '杨笠', '何广智'],
    description: '全新一季脱口秀大会重磅回归！来自各行各业的脱口秀演员齐聚一堂，用幽默诙谐的方式讲述生活中的酸甜苦辣。谁能成为本季的脱口秀大王？欢笑与感动，尽在脱口秀大会第六季。',
    tags: ['喜剧', '脱口秀', '综艺', '搞笑'],
    isHot: true,
    isNew: false,
    isVip: false,
    updateDate: '2026-07-15',
    episodeInfo: '更新至8期',
    stills: [
      'https://readdy.ai/api/search-image?query=Bright%20colorful%20stage%20with%20spotlight%20and%20microphone%2C%20comedy%20show%20scene%2C%20energetic%20atmosphere&width=800&height=450&seq=still-10-1&orientation=landscape',
    ],
  },
  {
    id: 11,
    title: '极限挑战第十季',
    englishTitle: 'Go Fighting Season 10',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20reality%20variety%20show%20poster%20with%20adventure%20theme%2C%20outdoor%20challenge%20aesthetic%2C%20dynamic%20action%20style%2C%20clean%20composition&width=600&height=840&seq=movie-poster-11&orientation=portrait',
    year: 2026,
    category: 'zongyi',
    subcategory: 'dalu',
    rating: 7.8,
    duration: '12期',
    region: '中国大陆',
    director: '',
    actors: ['黄渤', '孙红雷', '黄磊', '罗志祥', '张艺兴', '迪丽热巴'],
    description: '极限男人帮再次集结，开启全新一季的挑战之旅。从城市到荒野，从科技到传统，每一期都有全新的主题和意想不到的挑战。友情、智慧、勇气的终极考验，谁才是真正的极限王者？',
    tags: ['真人秀', '挑战', '搞笑', '竞技'],
    isHot: false,
    isNew: true,
    isVip: false,
    updateDate: '2026-08-06',
    episodeInfo: '更新至5期',
    stills: [
      'https://readdy.ai/api/search-image?query=Outdoor%20adventure%20challenge%20scene%20with%20group%20of%20people%2C%20dynamic%20action%2C%20variety%20show%20cinematography&width=800&height=450&seq=still-11-1&orientation=landscape',
    ],
  },
  {
    id: 12,
    title: '斗罗大陆：神界传说',
    englishTitle: 'Soul Land: Legend of the Gods',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20anime%20poster%20with%20magical%20warrior%20and%20spirit%20beasts%2C%20fantasy%20animation%20style%2C%20vibrant%20colors%2C%20clean%20dark%20background&width=600&height=840&seq=movie-poster-12&orientation=portrait',
    year: 2026,
    category: 'dongman',
    subcategory: 'guoman',
    rating: 9.2,
    duration: '52集',
    region: '中国大陆',
    director: '沈乐平',
    actors: [],
    description: '唐三成神之后，踏入了更为广阔的神界。在这个诸神林立的领域，唐三需要面对全新的挑战和更强大的对手。为了守护挚爱的家人和伙伴，他必须在神界中闯出一片属于自己的天地。国漫巅峰之作，视觉盛宴。',
    tags: ['玄幻', '热血', '战斗', '国漫'],
    isHot: true,
    isNew: true,
    isVip: false,
    updateDate: '2026-08-10',
    episodeInfo: '更新至38集',
    stills: [
      'https://readdy.ai/api/search-image?query=Epic%20fantasy%20anime%20scene%20with%20magical%20battle%20and%20spirit%20creatures%2C%20vibrant%20colors%2C%20Chinese%20animation%20style&width=800&height=450&seq=still-12-1&orientation=landscape',
    ],
  },
  {
    id: 13,
    title: '狐妖小红娘·竹业篇',
    englishTitle: 'Fox Spirit Matchmaker: Bamboo Industry',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20romance%20anime%20poster%20with%20fox%20spirit%20girl%20and%20bamboo%20forest%2C%20beautiful%20animation%20style%2C%20soft%20pastel%20colors%2C%20clean%20composition&width=600&height=840&seq=movie-poster-13&orientation=portrait',
    year: 2025,
    category: 'dongman',
    subcategory: 'guoman',
    rating: 9.0,
    duration: '24集',
    region: '中国大陆',
    director: '王昕',
    actors: [],
    description: '讲述了涂山狐妖一族与人类之间的情感纠葛。竹叶青蛇妖与人类书生的千年爱恋，在轮回中不断上演。当命运的齿轮再次转动，他们能否打破宿命的枷锁，收获真正的幸福？唯美国风，感人至深。',
    tags: ['恋爱', '奇幻', '古风', '催泪'],
    isHot: false,
    isNew: false,
    isVip: false,
    updateDate: '2025-10-20',
    episodeInfo: '已完结',
    stills: [
      'https://readdy.ai/api/search-image?query=Beautiful%20bamboo%20forest%20with%20soft%20mist%20and%20sunlight%2C%20romantic%20ancient%20Chinese%20atmosphere&width=800&height=450&seq=still-13-1&orientation=landscape',
    ],
  },
  {
    id: 14,
    title: '火影忍者：新时代',
    englishTitle: 'Naruto: New Era',
    poster: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20poster%20with%20ninja%20characters%20in%20action%20pose%2C%20dynamic%20animation%20style%2C%20vibrant%20colors%2C%20clean%20dark%20background&width=600&height=840&seq=movie-poster-14&orientation=portrait',
    year: 2026,
    category: 'dongman',
    subcategory: 'riman',
    rating: 8.3,
    duration: '26集',
    region: '日本',
    director: '',
    actors: [],
    description: '鸣人成为七代目火影多年后，木叶村迎来了和平繁荣的新时代。然而，暗处的新威胁正在悄然滋生。新一代忍者们将继承前辈的意志，踏上属于他们自己的忍者之路。火之意志，永不熄灭。',
    tags: ['热血', '战斗', '冒险', '日漫'],
    isHot: true,
    isNew: false,
    isVip: true,
    updateDate: '2026-06-10',
    episodeInfo: '更新至18集',
    stills: [
      'https://readdy.ai/api/search-image?query=Anime%20ninja%20village%20scene%20with%20action%20and%20dynamic%20poses%2C%20vibrant%20Japanese%20animation%20style&width=800&height=450&seq=still-14-1&orientation=landscape',
    ],
  },
  {
    id: 15,
    title: '流浪地球3',
    englishTitle: 'The Wandering Earth 3',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20disaster%20film%20poster%20with%20massive%20planet%20engines%20in%20space%2C%20epic%20cinematic%20style%2C%20dark%20atmospheric%2C%20professional%20movie%20poster&width=600&height=840&seq=movie-poster-15&orientation=portrait',
    year: 2027,
    category: 'dianying',
    subcategory: 'kehuan',
    rating: 0,
    duration: '待定',
    region: '中国大陆',
    director: '郭帆',
    actors: ['吴京', '刘德华', '李雪健', '赵今麦'],
    description: '太阳急速老化，人类在地球表面建造了上万座行星发动机，推动地球逃离太阳系，前往4.2光年外的新家园。在漫长的流浪之旅中，人类将面临前所未有的挑战和抉择。中国科幻电影的里程碑之作。',
    tags: ['科幻', '灾难', '太空', '史诗'],
    isHot: true,
    isNew: true,
    isVip: false,
    updateDate: '2026-08-01',
    episodeInfo: '即将上映',
    stills: [
      'https://readdy.ai/api/search-image?query=Massive%20planet%20engines%20on%20frozen%20earth%20surface%20in%20space%2C%20epic%20sci-fi%20cinematic%20scene&width=800&height=450&seq=still-15-1&orientation=landscape',
    ],
  },
  {
    id: 16,
    title: '乘风破浪的姐姐第五季',
    englishTitle: 'Sisters Who Make Waves S5',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20music%20variety%20show%20poster%20with%20elegant%20women%20on%20stage%2C%20glamorous%20aesthetic%2C%20sparkling%20lights%2C%20clean%20dark%20background&width=600&height=840&seq=movie-poster-16&orientation=portrait',
    year: 2026,
    category: 'zongyi',
    subcategory: 'dalu',
    rating: 7.5,
    duration: '12期',
    region: '中国大陆',
    director: '',
    actors: ['那英', '宁静', '张雨绮', '万茜', '李斯丹妮'],
    description: '30位30+的姐姐们再次集结，用实力证明年龄从来不是限制。唱歌、跳舞、团队协作，每一场公演都是一次华丽的蜕变。谁将C位出道，成为本季的闪耀之星？敬请期待。',
    tags: ['音乐', '舞蹈', '女性', '竞技'],
    isHot: false,
    isNew: false,
    isVip: true,
    updateDate: '2026-05-20',
    episodeInfo: '已完结',
    stills: [
      'https://readdy.ai/api/search-image?query=Elegant%20stage%20performance%20with%20sparkling%20lights%20and%20female%20performers%2C%20glamorous%20variety%20show&width=800&height=450&seq=still-16-1&orientation=landscape',
    ],
  },
  {
    id: 17,
    title: '长津湖之水门桥',
    englishTitle: 'The Battle at Lake Changjin II',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20war%20film%20poster%20with%20soldiers%20in%20snow%20battlefield%2C%20epic%20historical%20cinematic%20style%2C%20dramatic%20lighting%2C%20professional%20movie%20poster&width=600&height=840&seq=movie-poster-17&orientation=portrait',
    year: 2025,
    category: 'dianying',
    subcategory: 'zhanzheng',
    rating: 8.9,
    duration: '149分钟',
    region: '中国大陆',
    director: '陈凯歌/徐克/林超贤',
    actors: ['吴京', '易烊千玺', '段奕宏', '朱亚文', '李晨'],
    description: '以抗美援朝战争第二次战役中的长津湖战役为背景，讲述了七连战士们在结束了新兴里和下碣隅里的战斗之后，又接到了更艰巨的任务——炸毁水门桥，阻断美军撤退的必经之路。冰雪与热血交织的壮烈史诗。',
    tags: ['战争', '历史', '爱国', '动作'],
    isHot: false,
    isNew: false,
    isVip: false,
    updateDate: '2025-09-30',
    episodeInfo: 'HD1080P',
    stills: [
      'https://readdy.ai/api/search-image?query=Snow%20covered%20battlefield%20with%20soldiers%2C%20epic%20war%20scene%2C%20dramatic%20winter%20cinematography&width=800&height=450&seq=still-17-1&orientation=landscape',
    ],
  },
  {
    id: 18,
    title: '沉默的真相',
    englishTitle: 'The Silent Truth',
    poster: 'https://readdy.ai/api/search-image?query=Suspense%20crime%20drama%20poster%20with%20lawyer%20and%20evidence%2C%20dark%20mysterious%20atmosphere%2C%20Chinese%20TV%20series%20aesthetic%2C%20clean%20composition&width=600&height=840&seq=movie-poster-18&orientation=portrait',
    year: 2024,
    category: 'dianshiju',
    subcategory: 'guochan',
    rating: 9.3,
    duration: '12集',
    region: '中国大陆',
    director: '陈奕甫',
    actors: ['廖凡', '白宇', '谭卓', '宁理'],
    description: '一起看似简单的自杀案件，背后却隐藏着一个令人毛骨悚然的真相。检察官江阳花费十年时间，用生命的代价追寻正义。这是一部关于信念、牺牲和正义的震撼之作。豆瓣9.3分神剧，不容错过。',
    tags: ['悬疑', '犯罪', '剧情', '高分'],
    isHot: false,
    isNew: false,
    isVip: false,
    updateDate: '2024-06-15',
    episodeInfo: '已完结',
    stills: [
      'https://readdy.ai/api/search-image?query=Dark%20courtroom%20scene%20with%20dramatic%20lighting%2C%20suspenseful%20Chinese%20legal%20drama%20cinematography&width=800&height=450&seq=still-18-1&orientation=landscape',
    ],
  },
  {
    id: 19,
    title: '地球脉动第三季',
    englishTitle: 'Planet Earth III',
    poster: 'https://readdy.ai/api/search-image?query=Nature%20documentary%20poster%20with%20stunning%20wildlife%20and%20landscapes%2C%20BBC%20style%2C%20vibrant%20natural%20colors%2C%20clean%20composition&width=600&height=840&seq=movie-poster-19&orientation=portrait',
    year: 2026,
    category: 'dianying',
    subcategory: 'jilupian',
    rating: 9.8,
    duration: '8集',
    region: '英国',
    director: '',
    actors: [],
    description: 'BBC史诗级自然纪录片重磅回归！历时四年，跨越六大洲四十多个国家，用最先进的摄影技术捕捉地球上最壮观、最罕见的自然奇观。从深海到高山，从极地到雨林，带你领略地球生命的无限魅力。',
    tags: ['纪录片', '自然', '动物', 'BBC'],
    isHot: false,
    isNew: true,
    isVip: true,
    updateDate: '2026-08-03',
    episodeInfo: '更新至6集',
    stills: [
      'https://readdy.ai/api/search-image?query=Stunning%20aerial%20view%20of%20wild%20nature%20landscape%20with%20wildlife%2C%20BBC%20documentary%20quality&width=800&height=450&seq=still-19-1&orientation=landscape',
    ],
  },
  {
    id: 20,
    title: '进击的巨人最终季完结篇',
    englishTitle: 'Attack on Titan Final Season',
    poster: 'https://readdy.ai/api/search-image?query=Dark%20anime%20poster%20with%20giant%20titan%20and%20soldiers%2C%20epic%20Japanese%20animation%20style%2C%20dramatic%20cinematic%2C%20clean%20dark%20background&width=600&height=840&seq=movie-poster-20&orientation=portrait',
    year: 2026,
    category: 'dongman',
    subcategory: 'riman',
    rating: 9.5,
    duration: '完结篇',
    region: '日本',
    director: '',
    actors: [],
    description: '人类与巨人之间的终极对决即将到来。艾伦·耶格尔做出了改变世界的选择，曾经的战友如今站在了对立面。自由与毁灭、希望与绝望，史诗级的最终决战拉开帷幕。动漫史上最震撼人心的完结篇。',
    tags: ['热血', '战斗', '暗黑', '史诗'],
    isHot: true,
    isNew: true,
    isVip: false,
    updateDate: '2026-08-11',
    episodeInfo: '已完结',
    stills: [
      'https://readdy.ai/api/search-image?query=Epic%20anime%20battle%20scene%20with%20giant%20creatures%20and%20destruction%2C%20dramatic%20action%2C%20dark%20atmosphere&width=800&height=450&seq=still-20-1&orientation=landscape',
    ],
  },
];